import React from 'react';

const AdminReports = () => {

  const reportTypes = [
    { title: 'Sales Report', description: 'Product sales analytics' },
    { title: 'Income Report', description: 'Commission analysis' },
    { title: 'User Report', description: 'Member statistics' },
    { title: 'Rank Report', description: 'Rank distribution overview' },
    { title: 'Payout Report', description: 'Withdrawal summary' },
    { title: 'Monthly Report', description: 'Monthly performance summary' }
  ];

  return (
    <div className="bg-[#F8FAFC] p-6 rounded-2xl">

      {/* Header */}
      <div className="mb-10">
        <h2 className="text-3xl font-bold text-[#0F2F3D]">
          Reports & Analytics
        </h2>
        <p className="text-gray-500 mt-1">
          Generate, download and analyze platform reports
        </p>
      </div>

      {/* Report Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">

        {reportTypes.map((report, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#E4572E] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          >
            <h3 className="text-xl font-bold text-[#0F2F3D] mb-2">
              {report.title}
            </h3>

            <p className="text-gray-500 text-sm mb-6">
              {report.description}
            </p>

            <div className="flex justify-between items-center">
              <span className="text-[#E4572E] font-semibold text-sm">
                Generate Report →
              </span>

              <span className="text-xs text-gray-400">
                PDF / Excel
              </span>
            </div>
          </div>
        ))}

      </div>

      {/* Quick Stats Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Report Summary */}
        <div className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#0F2F3D]">
          <h3 className="text-xl font-bold text-[#0F2F3D] mb-6">
            Report Summary
          </h3>

          <div className="space-y-4 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Reports Generated</span>
              <span className="font-bold text-[#E4572E]">156</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">This Month</span>
              <span className="font-semibold text-[#0F2F3D]">23</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">Last Report</span>
              <span className="font-semibold text-[#0F2F3D]">2024-01-15</span>
            </div>
          </div>
        </div>

        {/* Popular Reports */}
        <div className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#E4572E]">
          <h3 className="text-xl font-bold text-[#0F2F3D] mb-6">
            Popular Reports
          </h3>

          <div className="space-y-4">

            <div className="p-4 bg-[#F8FAFC] rounded-xl hover:bg-[#E4572E]/5 transition-all">
              <p className="font-semibold text-[#0F2F3D]">
                Monthly Sales Report
              </p>
              <p className="text-xs text-gray-500">
                Downloaded 45 times
              </p>
            </div>

            <div className="p-4 bg-[#F8FAFC] rounded-xl hover:bg-[#E4572E]/5 transition-all">
              <p className="font-semibold text-[#0F2F3D]">
                User Growth Report
              </p>
              <p className="text-xs text-gray-500">
                Downloaded 32 times
              </p>
            </div>

          </div>
        </div>

      </div>

    </div>
  );
};

export default AdminReports;